import React from 'react';
import { Form } from 'antd';
import { useHistory } from 'react-router-dom';
import {
  DividerContainer,
  ButtonBackData,
  PageLayout,
  TableStudentsData,
} from '@BUP/components';
import { useTranslation } from 'react-i18next';
import styles from './active-sociogram.module.css';

const ActiveSociogramPage = () => {
  const [t] = useTranslation();
  const history = useHistory();

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer
        title={t('pages.data.instruments.activeSociogramTitle')}
      />
      <p className={styles.introText}>
        {t('pages.data.instruments.activeSociogramDescription')}
      </p>
      <Form>
        <TableStudentsData hasSelection />
      </Form>
    </PageLayout>
  );
};

export default ActiveSociogramPage;
